import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {Messages} from "@app/constants/Messages";

export const showSuccessMessageSaveData = (statusCode) => {
    if (statusCode === ResponseCode.SUCCESS) {
        toast.success(Messages.processSuccess);
    } else if (statusCode === ResponseCode.HAVE_DIFF_FIELD_ONE_VALUE) {
        toast.warning(Messages.otherUserInputDiffValueOfFieldOne);
    }
}
